import RequestService from './request-service';

/**
 * Sports combo data
 */
export default class SportsMarketsUs extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Endpoint url
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.sportsMarketsUs;
    /**
     * Method type
     * @type {string}
     */
    this.method = 'get';
    this.headers = null;
    this.getParams = {
      Culture: this.$config.defaultHeaders.Culture,
    }
  }
}
